const styles = (theme) => ({
  label: {
    display: 'flex',
    alignItems: 'center',
    height: '50px',
    color: theme.color.black_80,
  },
  icon: {
    height: '50px',
    width: '25px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '15px',
  },
  checkbox: {
    marginLeft: 'auto',
  },
  checkedIcon: {
    fill: theme.color.green,
  },
});

export default styles;
